import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticlesNames,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconUserValidation from '@/icons/UserValidation.svg';

export const ArticleValidationAutoAcceptedActivity = ({
  activities,
  displayArticleName,
}: {
  activities: ActivityOfType<'article_validation_auto_accepted'>[];
  displayArticleName: boolean;
}) => {
  const firstActivity = activities[0];

  const articleName = (
    <BaseActivityArticlesNames activities={activities} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={firstActivity.createdAt}
      type="primary"
      icon={<IconUserValidation />}
      message={
        <BaseActivityText>
          {activities.length > 1 ? (
            <Trans id="activities.article_validation_auto_accepted.message.plural">
              Client validation was automatically accepted for the items {articleName}
            </Trans>
          ) : (
            <Trans id="activities.article_validation_auto_accepted.message">
              Client validation was automatically accepted for the item {articleName}
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
